import type React from 'react';

import { Link, Text } from '@change/ds-core-ui';

import { Translate, TranslateHtml } from '@change-corgi/core-react/i18n';

import { NameInput } from './components/NameInput';
import { PaymentMethodSelectorWrapper } from './components/PaymentMethodSelectorWrapper';
import { UpdatePaymentMethod } from './components/UpdatePaymentMethod';
import { usePaymentInfo } from './hooks/usePaymentInfo';

export const PaymentInfo: React.FC = () => {
	const {
		data: { currentCardInfo, currentCardInfoKey, showUpdatePayment },
	} = usePaymentInfo();

	return (
		<div className="flex flex-col gap-4">
			<Text as="h2" size="x-small" variant="heading" fontWeight="bold">
				<Translate value="corgi.membership.manage.payment_information.label" />
			</Text>

			<Text as="p" data-testid="current-payment-method-info" data-qa="current-payment-method-info">
				<TranslateHtml
					value="corgi.membership.manage.payment_information.description"
					replacements={{
						paymentMethod: <b>{currentCardInfo}</b>,
						contactEmail: (
							<Link href="mailto:support@change.org" target="_blank" bold data-qa="support-email-link">
								support@change.org
							</Link>
						),
					}}
				/>
			</Text>

			{showUpdatePayment && (
				<>
					<Text as="h3" size="medium" fontWeight="bold">
						<Translate value="fe.pages.subscriptions.manage.update_payment_info" />
					</Text>

					<PaymentMethodSelectorWrapper data-qa="payment-method-selector" key={currentCardInfoKey}>
						<div className="flex flex-col gap-2">
							<NameInput data-qa="name-input" />

							<UpdatePaymentMethod data-qa="update-payment-method" />
						</div>
					</PaymentMethodSelectorWrapper>
				</>
			)}
		</div>
	);
};
